import template from './panel.component.html';
import { InstructionsController as controller } from './panel.controller';
import './style.less';

export default {
	bindings: {
		instructions: '<',
		onEdited: '&',
		onRemoved: '&'
	},
	controller,
	require: {
		activityEditorController: '^activityEditor'
	},
	template
} as ng.IComponentOptions;
